export default "__VITE_ASSET__DtRMjxv5__"